










import Vue from 'vue';
import isGranted from '@/auth/isGranted';
import { openModal } from 'mycorems-app-shared';
import FetchEmailCampaignsModal from './FetchEmailCampaignsModal.vue';

export default Vue.extend({
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  methods: {
    open(): void {
      openModal(FetchEmailCampaignsModal, {
        accountId: this.accountId,
      }).onOk(() => {
        this.$emit('fetched');
      });
    },
    isGranted,
  },
});
